import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "f3efd27b9c8d75615a09031e928157f2.jpg","uri@2x": __webpack_public_path__ + "01aa0711503a871d233da0eb1bba77af.jpg","uri@3x": __webpack_public_path__ + "f8990391a96f0907431a94e5d6b2d152.jpg",
    width: 1024,
    height: 550
});